module.exports = __webpack_public_path__ + "img/suzuki-baleno.2d815740.jpg";